import { observer } from 'mobx-react';

import {
  ToggleButtonGroup,
  ToggleButtonGroupItem,
} from '../../../../app/shared/components/ToggleButtonGroup/ToggleButtonGroup';
import { ExpansionToggleTranslation } from '../../../localization/ModuleTranslation';
import ExpansionState from '../ExpansionState';

const OPTION_IDS = {
  CollapseAll: 'collapseAll',
  ExpandAll: 'expandAll',
} as const;

interface ExpansionToggleProps {
  expansion: ExpansionState;
  translation: ExpansionToggleTranslation;
  className?: string;
}

const ExpansionToggle = observer(({ className, expansion, translation }: ExpansionToggleProps) => {
  const handleSelectionChange = (id: string) => {
    if (id === OPTION_IDS.ExpandAll) {
      expansion.expandAll();
    } else {
      expansion.collapseAll();
    }
  };

  return (
    <ToggleButtonGroup
      className={className}
      selectedItemId={expansion.areAllExpanded ? OPTION_IDS.ExpandAll : OPTION_IDS.CollapseAll}
      size="small"
      aria-label={translation.label}
      onSelectionChange={handleSelectionChange}
    >
      {Object.values(OPTION_IDS).map((id) => (
        <ToggleButtonGroupItem key={id} id={id}>
          {translation.options[id]}
        </ToggleButtonGroupItem>
      ))}
    </ToggleButtonGroup>
  );
});

export default ExpansionToggle;
